import { ComponentView, ObservableArray, View, ViewGenerator, ViewModel } from "binder"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { PaginatorViewModel } from "../../paginator/paginator-viewModel";
import { ITemplateSelector } from "../../templateSelector";
import { getAsBoolean } from "../../utilities";
import { ColumnViewModel } from "../column/column-viewModel";
import { ExTableViewModel } from "../exTable-viewModel";

export class ExtablePhoneView extends ComponentView<ExTableViewModel>{
    GetViewUniqueId(): string {
        return "V-D1E8015B-816F-4527-AFB6-498027A1DA05"
    }
    loadHtml(): string {
        let element = require('./extablePhone.html').default;
        let style = require('./extablePhone.less');
        return element;
    }
    constructor() {
       super();
       this.displayContentForTBody = false;
    }

    private itemTemplate : Node;
    templateSelector(vm){
        let template : any;
        let newNode : Element;
        if(this.itemtemplateselector && this.itemtemplateselector.getTemplate){
            template = this.itemtemplateselector.getTemplate(vm,this.templateselectorfunction);
            if(template){
                newNode = ViewGenerator.CreateFromPrototypeAndViewModel(template,vm);
            }
        }
        if(newNode==null){
            template = this.itemTemplate;
            newNode = ViewGenerator.GetNodeByTemplate(vm,template);
        }
        return newNode;
    }
    append(...nodes: (Node | string)[]): void{
        let table = this.firstlevelElement.querySelector('.V-B7445FEA-BFC9-4BEE-8B62-92093F23D6F0-table');
        nodes.forEach(node=>{
            if(node instanceof HTMLTableSectionElement || node instanceof HTMLTableColElement){
                if(node.nodeName.toUpperCase()=='THEAD' || node.nodeName.toUpperCase()=="COLGROUP"){
                    table.prepend(node);
                }else if(node.nodeName.toUpperCase()=='TBODY'){
                    if(node.classList.contains("template")){
                        let template = <HTMLElement>node;
                        this.itemTemplate = this.removeAsTemplate(template);
                        this.displayContentForTBody = true;
                    }else if(node.childElementCount>0 && node.children[0].classList.contains("template")){
                        let template = <HTMLElement>node.children[0];
                        this.itemTemplate = this.removeAsTemplate(template);
                    }
                }else{
                    table.append(node);
                }
            }
        });
    }

    public set showingitems(v: ObservableArray<ViewModel>) { 
        this._showingitems = v; 
        this.updateInternalItems();
    } public get showingitems(): ObservableArray<ViewModel> { return this._showingitems;} private _showingitems: ObservableArray<ViewModel>;
    public set internalShowingItems(v: ObservableArray<ViewModel>) { this._internalShowingItems = v; } public get internalShowingItems(): ObservableArray<ViewModel> { return this._internalShowingItems;} private _internalShowingItems: ObservableArray<ViewModel>;
    
    public set paginator(v: PaginatorViewModel) { this._paginator = v; } public get paginator(): PaginatorViewModel { return this._paginator;} private _paginator: PaginatorViewModel;
    public set stickyheader(v: boolean) { this._stickyheader = getAsBoolean(v); } public get stickyheader(): boolean { return this._stickyheader;} private _stickyheader: boolean;
    public set hidepages(v: boolean) { this._hidepages = v; } public get hidepages(): boolean { return this._hidepages;} private _hidepages: boolean;
    public set shallshowfullsearch(v: boolean) { this._shallshowfullsearch = v; } public get shallshowfullsearch(): boolean { return this._shallshowfullsearch;} private _shallshowfullsearch: boolean;
    public set fullsearchstring(v: string) { this._fullsearchstring = v; } public get fullsearchstring(): string { return this._fullsearchstring;} private _fullsearchstring: string;
    public set displayContentForTBody(v: boolean) { this._displayContentForTBody = v; } public get displayContentForTBody(): boolean { return this._displayContentForTBody;} private _displayContentForTBody: boolean;
    public set columns(v: ObservableArray<ColumnViewModel>) { this._columns = v; } public get columns(): ObservableArray<ColumnViewModel> { return this._columns;} private _columns: ObservableArray<ColumnViewModel>;
    public set internalShowColumnsList(v: boolean) { this._internalShowColumnsList = v; } public get internalShowColumnsList(): boolean { return this._internalShowColumnsList;} private _internalShowColumnsList: boolean;
    public set horizontalscroll(v: boolean) { this._horizontalscroll = v; } public get horizontalscroll(): boolean { return this._horizontalscroll;} private _horizontalscroll: boolean;
    public set canexportexcel(v: boolean) { this._canexportexcel = getAsBoolean(v); } public get canexportexcel(): boolean { return this._canexportexcel;} private _canexportexcel: boolean;
    public set canexportpdf(v: boolean) { this._canexportpdf = getAsBoolean(v); } public get canexportpdf(): boolean { return this._canexportpdf;} private _canexportpdf: boolean;

    public set itemtemplateselector(v: ITemplateSelector) { 
        this._itemtemplateselector = v; 
        this.updateInternalItems();
    } public get itemtemplateselector(): ITemplateSelector { return this._itemtemplateselector;} private _itemtemplateselector: ITemplateSelector;
    public set templateselectorfunction(v: string) { 
        this._templateselectorfunction = v; 
        this.updateInternalItems();
    } public get templateselectorfunction(): string { return this._templateselectorfunction;} private _templateselectorfunction: string;
    public set importanthasselectorfunction(v: boolean) { this._importanthasselectorfunction = getAsBoolean(v); } public get importanthasselectorfunction(): boolean { return this._importanthasselectorfunction;} private _importanthasselectorfunction: boolean;

    updateInternalItems(){
        if((this.importanthasselectorfunction??false)==false){
            this.internalShowingItems = this.showingitems;
        }else{
            if(this.itemtemplateselector!=null && stringIsNullOrEmpty(this.templateselectorfunction)==false){
                this.internalShowingItems = this.showingitems;
            }
        }
    }
}

